import React, { useState } from 'react';
import { Fade, Stack, Box, IconButton, Grid, Typography } from "@mui/material";
import CloseIcon from '@mui/icons-material/Close';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import { useTranslation } from 'react-i18next';

const videoList = [
 

{
    "id":  "35JnTHMaNE4",
    "title":  "十奏嚴嵩",
    "uploadDate":  "2024-08-08"
},
{
    "id":  "oyLUT6FrdJo",
    "title":  "打金枝",
    "uploadDate":  "2024-08-08"
},
{
    "id":  "Y5mGi33wYzY",
    "title":  "穆桂英招親",
    "uploadDate":  "2024-08-08"
},
{
    "id":  "nUCRApHPA7Q",
    "title":  "雙陽公主追夫",
    "uploadDate":  "2024-08-08"
},
{
    "id":  "s5xmTOsEFFk",
    "title":  "朱弁回朝之哭主",
    "uploadDate":  "2024-08-08"
},
{
    "id":  "bwQnUzAp2OY",
    "title":  "滿江紅",
    "uploadDate":  "2024-08-08"
},
{
    "id":  "N805oGywwvc",
    "title":  "楊繼業闖碑",
    "uploadDate":  "2024-08-08"
},
{
    "id":  "MQ0biPAyzi8",
    "title":  "水漫金山",
    "uploadDate":  "2024-08-08"
},
{
    "id":  "UAQOQeXnPcE",
    "title":  "水調歌頭",
    "uploadDate":  "2024-08-08"
},
{
    "id":  "HSHGzeXOkmU",
    "title":  "香港粵劇戲服設計淺談 Cantonese Opera\u0027s Costume Design in Hong Kong",
    "uploadDate":  "2022-10-10"
},

{
    "id":  "HQJ0bQ3x2AI",
    "title":  "Omni Cantonese 專訪:亞裔文化月粵劇服裝設計講座及展覽",
    "uploadDate":  "2022-05-15"
},
{
    "id":  "IyLQGZ6Fr_E",
    "title":  "林家聲博士與粵劇小豆丁 - 粵劇小豆丁十週年特輯（第二集）",
    "uploadDate":  "2021-10-01"
},
{
    "id":  "jLoKnYYRLak",
    "title":  "粵劇小豆丁十週年特輯 (第一集) Starlets 10th Anniversary Special",
    "uploadDate":  "2021-08-21"
},
{
    "id":  "K-8hyib9snQ",
    "title":  "亞裔文化月2021粵劇小豆丁折子戲特輯:（三）搶傘",
    "uploadDate":  "2021-05-30"
},
{
    "id":  "Qa0F7Msqzbg",
    "title":  "亞裔文化月2021粵劇小豆丁折子戲特輯:（二）盜仙草",
    "uploadDate":  "2021-05-30"
},
{
    "id":  "7uwaHVw9Lxk",
    "title":  "亞裔文化月2021粵劇小豆丁折子戲特輯（一）: 小放牛",
    "uploadDate":  "2021-05-30"
},
{
    "id":  "SzAsq6q3FDs",
    "title":  "粵劇小豆丁祝大家母親節快樂！",
    "uploadDate":  "2021-05-07"
},
{
    "id":  "yzkgDNJXhFY",
    "title":  "幻覺離恨天之思凡 - 牛年賀歲粵劇特輯 (十)",
    "uploadDate":  "2021-02-14"
},
{
    "id":  "ks9jde03vvY",
    "title":  "苧蘿訪艷 (選段) - 牛年賀歲粵劇特輯 (九)",
    "uploadDate":  "2021-02-14"
},
{
    "id":  "r6BweZ2ripc",
    "title":  "木蘭辭 - 牛年賀歲粵劇特輯 (八)",
    "uploadDate":  "2021-02-14"
},
{
    "id":  "WCuPS5RfgE0",
    "title":  "紅鸞喜 (選段) - 牛年賀歲粵劇特輯 (七)",
    "uploadDate":  "2021-02-13"
},
{
    "id":  "bfsJaPKkjJA",
    "title":  "拾玉鐲 (下) - 牛年賀歲粵劇特輯 (六)",
    "uploadDate":  "2021-02-13"
},
{
    "id":  "cjH-v9jDyZg",
    "title":  "拾玉鐲 (上) - 牛年賀歲粵劇特輯 (五)",
    "uploadDate":  "2021-02-13"
},
{
    "id":  "adXRJKEdKdw",
    "title":  "寶蓮燈之救母 - 牛年賀歲粵劇特輯 (四)",
    "uploadDate":  "2021-02-12"
},
{
    "id":  "81LSAJFXsQg",
    "title":  "寶蓮燈之鍊斧 - 牛年賀歲粵劇特輯 (三)",
    "uploadDate":  "2021-02-12"
},
{
    "id":  "G2r-gYeyTMo",
    "title":  "寶蓮燈之肇禍 - 牛年賀歲粵劇特輯 (二)",
    "uploadDate":  "2021-02-12"
},
{
    "id":  "pkR066SUTr8",
    "title":  "孫悟空三打白骨精之智激 - 牛年賀歲粵劇特輯 (一)",
    "uploadDate":  "2021-02-12"
},
{
    "id":  "lpVOpp1sd_g",
    "title":  "粵劇小豆丁賀年片2021 Starlight Chinese Opera Chinese New Year Greeting",
    "uploadDate":  "2021-02-11"
},
{
    "id":  "XL3l_dfABq4",
    "title":  "[第五集]林家聲之『博、精、深、新』粵劇講座回顧: 探討粵劇發展",
    "uploadDate":  "2021-02-05"
},
{
    "id":  "4y8zpYV4tyE",
    "title":  "[第四集]林家聲之『博、精、深、新』粵劇講座回顧:「周瑜」角色之演繹",
    "uploadDate":  "2021-01-22"
},
{
    "id":  "rHKrGrYmqx4",
    "title":  "[第三集]林家聲之『博、精、深、新』粵劇講座回顧:「張君瑞」角色之演繹",
    "uploadDate":  "2021-01-08"
},
{
    "id":  "VMO8I7QiP-A",
    "title":  "[第二集]林家聲之『博、精、深、新』粵劇講座回顧:「林沖」角色之演繹",
    "uploadDate":  "2020-12-25"
},
{
    "id":  "Wn8CMosKqbs",
    "title":  "[第一集]林家聲之『博、精、深、新』粵劇講座回顧:「武松」角色之演繹",
    "uploadDate":  "2020-12-11"
},
{
    "id":  "7naETOj12ps",
    "title":  "[預告] 林家聲之「博. 精. 深. 新」粤劇講座回顧",
    "uploadDate":  "2020-11-30"
},
{
    "id":  "2EE1OwcLumE",
    "title":  "小豆丁母親節祝福 Starlet Mother\u0027s Day Greeting",
    "uploadDate":  "2020-05-10"
},
{
    "id":  "qGRDpI0JdUo",
    "title":  "香港青年精英粵劇匯演 2018 Trailer",
    "uploadDate":  "2018-08-26"
},
{
    "id":  "G5YH_WnIFV8",
    "title":  "Starlets Look Back in the Years 粵劇小豆丁回顧與前瞻",
    "uploadDate":  "2017-10-31"
},
{
    "id":  "34aJQaEYFXw",
    "title":  "小豆丁跟ANGRY BIRD 一起學粵劇 【鳳閣恩仇未了情】",
    "uploadDate":  "2014-01-27"
},
{
    "id":  "gN4Y7_vJMko",
    "title":  "小豆丁跟ANGRY BIRD 一起學粵劇",
    "uploadDate":  "2014-01-27"
},
{
    "id":  "0xFg_17m3mY",
    "title":  "Starlets on FairchildTV news (10 Aug 2013)",
    "uploadDate":  "2013-08-30"
},
{
    "id":  "ROICD-hDrJ0",
    "title":  "Welcome to Starlight Chinese Opera!",
    "uploadDate":  "2013-08-23"
},
{
    "id":  "irWzsdiFH9Y",
    "title":  "【粵劇小豆丁月記】─ 學唱新曲盜仙草 Learning Diary of Cantonese Opera Starlets",
    "uploadDate":  "2013-05-23"
},
{
    "id":  "VU4pho13duo",
    "title":  "林家聲藏品展2012精華篇",
    "uploadDate":  "2013-02-11"
},
{
    "id":  "Ri01KcT0gTQ",
    "title":  "Chinese Business Event 13 Oct 2012",
    "uploadDate":  "2012-10-29"
},
{
    "id":  "pxMF9Gz44Lg",
    "title":  "Chinese Business Event (Behind the Scene) 13 Oct 2012",
    "uploadDate":  "2012-10-29"
},
{
    "id":  "LM9N9-JeMoA",
    "title":  "Mid-Autumn Festival performance at Mon Sheong long term care center",
    "uploadDate":  "2012-10-15"
},
{
    "id":  "wGkHH7LLlqA",
    "title":  "林家聲藏品展 \"Brilliance, Virtuosity, and Creativity on Stage\"",
    "uploadDate":  "2012-10-14"
},
{
  "id":  "eLM5NkXl6fg",
  "title":  "粵劇小豆丁 演出",
  "uploadDate":  "2012-10-13"
},
{
  "id":  "2MPU4PfrXA0",
  "title":  "Starlet radio interview section 1 (寶新聲粵劇小豆丁電台訪問2012.02.17)",
  "uploadDate":  "2012-02-24"
},
{
  "id":  "2MPU4PfrXA0",
  "title":  "Alice in Opera Wonderland, [英]語梨園",
  "uploadDate":  "2007-04-16"
}];

function Video() {
  const { t } = useTranslation();
  const [showOverlay, setShowOverlay] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);

  const handleOpenOverlay = () => setShowOverlay(true);
  const handleCloseOverlay = () => setShowOverlay(false);

  const handlePrev = () => {
    setCurrentIndex((prev) => (prev === 0 ? videoList.length - 1 : prev - 1));
  };

  const handleNext = () => {
    setCurrentIndex((prev) => (prev === videoList.length - 1 ? 0 : prev + 1));
  };

  const handleThumbnailClick = (index) => {
    setCurrentIndex(index);
    handleOpenOverlay();
  };

  return (
    <Stack direction="row" sx={{  justifyContent: "center", minHeight: "65.5vh", backgroundColor: "background.main" }}>
      <Fade in={true} timeout={2000}>
        <Stack direction="column" marginBottom="1vh" height="100%" width={{ md: "85%", xs: "100%" }}>

          <Grid container spacing={3} mt={5}>
            {videoList.map((video, idx) => (
              <Grid item xs={12} sm={6} md={4} key={video.id}>
                <Box
                  onClick={() => handleThumbnailClick(idx)}
                  sx={{
                    cursor: "pointer",
                    borderRadius: 2,
                    overflow: "hidden",
                    boxShadow: 2,
                    '&:hover': { boxShadow: 4,   transform: "scale(1.03)" }
                  }}
                >
                  <Box
                    component="img"
                    src={`https://img.youtube.com/vi/${video.id}/hqdefault.jpg`}
                    alt={video.title}
                    sx={{ width: "100%", aspectRatio: "16/9", objectFit: "cover" }}
                  />
                  <Box sx={{ p: 2 }}>
                    <Typography variant="subtitle1" fontWeight="bold">{video.title}</Typography>
                    <Typography variant="caption" color="text.secondary">{video.uploadDate}</Typography>
                  </Box>
                </Box>
              </Grid>
            ))}
          </Grid>

          {showOverlay && (
            <Box
              sx={{
                position: 'fixed',
                top: 0,
                left: 0,
                width: '100vw',
                height: '100vh',
                bgcolor: 'rgba(0, 0, 0, 0.9)',
                zIndex: 1300,
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                px: { xs: 2, sm: 3, md: 4 },
              }}
            >
              {/* Close Button */}
              <IconButton
                onClick={handleCloseOverlay}
                sx={{ position: 'absolute', top: 16, left: 16, color: 'white', zIndex: 2 }}
              >
                <CloseIcon />
              </IconButton>

              {/* Navigation */}
              <IconButton
    onClick={handlePrev}
    sx={{
      position: 'absolute',
      left: {lg:"1vw",md:3, xs:"1vw"},
      color: 'white',
      zIndex: 2,
      backgroundColor: 'rgba(0,0,0,0.4)',
      '&:hover': { backgroundColor: 'rgba(0,0,0,0.6)' },
    }}
  >
    <ArrowBackIosNewIcon fontSize="large" />
  </IconButton>

  <IconButton
  onClick={handleNext}
  sx={{
    position: 'absolute',
    right: {lg:"5vw", xs: "6vw", sm: 12 },
    color: 'white',
    zIndex: 2,
    backgroundColor: 'rgba(0,0,0,0.4)',
    '&:hover': { backgroundColor: 'rgba(0,0,0,0.6)' },
  }}
>
  <ArrowForwardIosIcon fontSize="large" />
</IconButton>

              {/* YouTube Video */}
              <Box sx={{ position: "relative", width: "100%", maxWidth: {lg:"70vw", xs:"100vw"}, aspectRatio: "16 / 9" }}>
            <iframe
              width="100%"
              height="100%"
              src={`https://www.youtube.com/embed/${videoList[currentIndex].id}?autoplay=1`}
              title={videoList[currentIndex].title}
              frameBorder="0"
              allow="autoplay; encrypted-media"
              allowFullScreen
            />
              </Box>

              {/* Thumbnail Scroll */}
              <Box sx={{ position: 'relative', width: '90%', maxWidth: 1200, mt: 3 }}>
                <IconButton
                  onClick={() => document.getElementById("video-thumb-scroll").scrollBy({ left: -150, behavior: 'smooth' })}
                  sx={{ position: 'absolute', left: -10, top: '50%', transform: 'translateY(-50%)', zIndex: 2, color: 'white', bgcolor: 'rgba(0,0,0,0.3)' }}
                >
                  <ArrowBackIosNewIcon />
                </IconButton>

                <IconButton
                  onClick={() => document.getElementById("video-thumb-scroll").scrollBy({ left: 150, behavior: 'smooth' })}
                  sx={{ position: 'absolute', right: -10, top: '50%', transform: 'translateY(-50%)', zIndex: 2, color: 'white', bgcolor: 'rgba(0,0,0,0.3)' }}
                >
                  <ArrowForwardIosIcon />
                </IconButton>

                <Box
                  id="video-thumb-scroll"
                  sx={{
                    overflowX: 'auto',
                    whiteSpace: 'nowrap',
                    py: 1,
                    px: 4,
                    scrollbarWidth: 'none',
                    '&::-webkit-scrollbar': { display: 'none' },
                  }}
                >
                  {videoList.map((video, index) => (
                    <Box
                      key={video.id}
                      component="img"
                      src={`https://img.youtube.com/vi/${video.id}/default.jpg`}
                      alt={video.title}
                      onClick={() => setCurrentIndex(index)}
                      sx={{
                        width: 80,
                        height: 60,
                        mx: 1,
                        borderRadius: 2,
                        border: currentIndex === index ? '3px solid white' : '2px solid transparent',
                        cursor: 'pointer',
                        objectFit: 'cover',
                        display: 'inline-block',
                        transition: 'transform 0.3s ease',
                        '&:hover': { transform: 'scale(1.05)' },
                      }}
                    />
                  ))}
                </Box>
              </Box>
            </Box>
          )}
        </Stack>
      </Fade>
    </Stack>
  );
}

export default Video;